import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'cps-admin';

  isAuth = false;
  showTime = false;
  showSnapshot = false;
  showMain = false;

  ngOnInit(): void {
    // Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    // Add 'implements OnInit' to the class.
    this.toggleAuth();
  }

  toggleAuth(){
    const curDate = new Date();
    const tokenExpire = new Date(localStorage.getItem('tokenExpire'));
    if (tokenExpire > curDate && localStorage.length > 1){
      this.isAuth = true;
      this.showMain = true;
    }
  }

  logOut(){
    this.isAuth = false;
    this.showTime = false;
    this.showSnapshot = false;
    this.showMain = false;
    localStorage.removeItem('token');
    localStorage.removeItem('tokenExpire');
  }

  toggleTime() {
    if (!this.showTime){
      this.showTime = !this.showTime;
      this.showMain = false;
      this.showSnapshot = false;
    }
  }

  toggleMain() {
    if (!this.showMain){
      this.showMain = !this.showMain;
      this.showTime = false;
      this.showSnapshot = false;
    }
  }
}
